module.exports = __webpack_public_path__ + "img/bespoke-cover.40860655.png";